import React from 'react';
import {Step} from 'react-joyride';
import {tourText} from '../../texts/analyticsText';
import {stepConfig} from './analyticsStepConfig';

export const getAnalyticsSteps = (): Step[] => {
  return stepConfig.map(({target, key}) => {
    const step = tourText[key as keyof typeof tourText];

    return {
      target,
      content: (
        <>
          {step.title && <h4 className="joyride-title">{step.title}</h4>}
          {step.description && <p>{step.description}</p>}
        </>
      ),
    };
  });
};
